export default "__VITE_ASSET__CrjkB9jO__"